import React from 'react';
import {
  InputBase as MuiInputBase,
  InputBaseProps as MuiInputBaseProps,
} from '@mui/material';

/**
 * Props that we do not want to include with InputBase.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
export type InputBaseBlockedPropKeys = keyof Pick<MuiInputBaseProps, 'color'>;

export interface InputBaseOwnProps {
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default true
   * @deprecated This prop is defaulted to true in Unify, and, for performance reasons, should not be set to false.
   *  See: https://github.com/Workiva/unify_ui/blob/2.29.0/packages/unify/src/components/InputBase/inputBaseStyleOverrides.tsx#L15-L26
   */
  disableInjectingGlobalStyles?: MuiInputBaseProps['disableInjectingGlobalStyles'];
}

/**
 * @deprecated Unsupported component: This is an internal component, use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export type InputBaseProps = Omit<
  MuiInputBaseProps,
  InputBaseBlockedPropKeys | keyof InputBaseOwnProps
> &
  InputBaseOwnProps;

/**
 * @deprecated Unsupported component: This is an internal component, use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
// eslint-disable-next-line deprecation/deprecation
export const InputBase = React.forwardRef<HTMLElement, InputBaseProps>(
  function UnifyInputBase(props, ref) {
    return <MuiInputBase {...props} ref={ref} />;
  }
);
